export const Canvas = () => (
    <canvas id="main-canvas">
        Your browser does <strong>not support</strong> the <code>&lt;canvas&gt;</code> element.
    </canvas>
);

export const getCanvas = (): HTMLCanvasElement => {
    const canvas = document.getElementById("main-canvas");

    if (canvas === null) {
        throw new Error("Canvas is not found in html layout");
    }

    if (!(canvas instanceof HTMLCanvasElement)) {
        throw new Error("No html canvas element.");
    }

    return canvas;
};

export const CanvasSettings = {
    Brightness: 1.0,
    Contrast: 1.0,
    Saturation: 1.0,
};

export function ApplyCanvasSettings(canvas: HTMLCanvasElement) {
    canvas.style.filter = `brightness(${CanvasSettings.Brightness}) contrast(${CanvasSettings.Contrast}) saturate(${CanvasSettings.Saturation})`;
}
